module.exports = __webpack_public_path__ + "media/images/github-copilot-plan_main-visual-illust-e5e3cadeba5201db040a5c9dd40a3482.png";